import React  from "react";
import { BrowserRouter as Router,Switch, Route } from "react-router-dom";

import HomePage from "./home/HomePage";
import Gallery from "./gallery/actress/ActressImage";
import News from "./news/News";
import Reviews from "./Reviews";
import Trailers from "./Trailers";
import Login from "./auth/Login";
import TrendingMovieDetails from "./TrendingMovieDetails";
import ImageGallery from "./gallery/actress/ActressAllImage";

import NewsFullDetails from "./news/NewsFullDetails";
import ActorImage from "./gallery/actor/ActorImage";
import ActorImages from "./gallery/actor/ActorImages.js"
import Movie from "./movie/Movie";
import ContactUs from "./footer/ContactUs";
import PrivacyPolicy from "./footer/PrivacyPolicy";
import SiteMap from "./footer/SiteMap";
function Home() {
  
  return (
    <Router>
    <div>
      <Switch>
        <Route path="/" exact component={HomePage} />
        <Route path="/actress" exact component={Gallery} />
        <Route path="/actress/:id" component={ImageGallery}/>
        <Route path="/actors" exact component={ActorImage}/>
        <Route path="/actors/:id" component={ActorImages}/>
        <Route path="/news" exact  component={News} />
        <Route path="/news/:id" component={NewsFullDetails}/>
        <Route path="/movie/:id"  component={TrendingMovieDetails} />
        <Route path="/reviews" component={Reviews} />
        <Route path="/trailers" component={Trailers} />
        <Route path="/login" component={Login} />
        <Route path="/movie" component={Movie} />
        <Route path="/contactUs" component={ContactUs}/>
        <Route path="/privacy_policy" component={PrivacyPolicy}/>
        <Route path="/siteMap" component={SiteMap}/>
        
      </Switch>
   
    </div>
    </Router>
  );
}

export default Home;
